@if(yourMindLogIsActive()){
  <div class="list-container">
    @if(loadingLogs()){
      <app-loading></app-loading>
    }@else {
      @for (item of listLogs(); track $index) {
        <div class="item-container" (click)="editLog(item)">
          <div class="item-mood">
            <div class="mood" [class]="getMoodColor(item.mood)">
              <img [src]="getMood(item.mood).image" [alt]="getMood(item.mood).label" class="mood-icon">
            </div>
          </div>
          <div class="item-details">
            <span>{{'historical.log_created_at' | translate:{id: item.id} }}</span>
            <span>{{item.created_at | date:'short'}}.</span>
            @if (item.logs_shared && item.logs_shared.length > 0) {
              <span>{{ 'historical.shared_with' | translate}}</span>
              @for (logShared of item.logs_shared; track logShared.id; let isLast = $last) {
                <span>
                  <strong>{{logShared.psychologists?.first_name + ' ' + logShared.psychologists?.last_name}}</strong>
                  @if (!isLast) {
                    <span>&nbsp;{{ 'historical.and' | translate}}&nbsp;</span>
                  }
                </span>
              }
            }
          </div>
          <div class="item-completition">
            <span>{{getPercentage(item)}}</span>
          </div>
        </div>
      }
      <div #logsScrollAnchor></div>
    }
  </div>
}@else if(sharedWithYouIsActive()){
  <app-users-sharing-logs
    [psychologist]="psychologist()"
    [filterBy]="filterBy()"
    (userSelected)="filterByUser($event)"
  >
  </app-users-sharing-logs>  
  <div class="list-shared-container">
    @if(loadingSharedLogs()){
      <app-loading></app-loading>
    }@else {
      @if(listShared()?.length !== 0){
        @for (item of listShared(); track $index) {
          <div class="item-container" (click)="viewLog(item)">
            <div class="item-mood">
              <div class="mood" [class]="getMoodColor(item.logs.mood)">
                <img [src]="getMood(item.logs.mood).image" [alt]="getMood(item.logs.mood).label" class="mood-icon">
              </div>
            </div>
            <div class="item-details">
              <span>{{'historical.log_created_at' | translate:{id: item.logs.id} }}</span>
              <span>{{item.logs.created_at | date:'short'}}</span>
              <span>{{'historical.log_created_by' | translate}} <strong>{{item.users.first_name + ' ' + item.users.last_name}}</strong></span>
              <span></span>
            </div>
            <div class="item-completition">
              <span>{{getPercentage(item.logs)}}</span>
            </div>
          </div>
        } 
        <div #logsSharedScrollAnchor></div>
      }@else if(listShared()?.length === 0){
        <div class="no-user-selected">
          <img src="/imgs/thinking.png">
          <div>{{ 'historical.select_name' | translate }}</div>
        </div>
      }
    }    
  </div>
}
